import { useLocation } from 'react-router-dom';
import { useEffect } from 'react';

import Hero from '../components/pages/homepage/Hero';
import Navigation from '../components/common/Navigation';
import Footer from '../components/common/Footer';
import PortfolioCTA from '../components/pages/homepage/PortfolioCTA';
import AboutMeBanner from '../components/pages/homepage/AboutMeBanner';
import AboutPage from './AboutPage';

const HomePage = () => {

  const location = useLocation();

  useEffect(() => {
    const id = location.state?.scrollToId;
    if (id) {
      const target = document.querySelector(id);
      if (target) {
        setTimeout(() => {
          target.scrollIntoView({ behavior: 'smooth' });
        }, 100); // Delay to ensure DOM is rendered
      }
    }
  }, [location]);

  return (
    <div id='HomePage'>
      <Navigation />
      <Hero />
      {/* <AboutMeBanner /> */}
      <AboutPage />
      <PortfolioCTA />
      <Footer />
    </div>
  )
}

export default HomePage;